// composables/queries/cbt/useCBTTestResults.ts
import { useGetTestResultsLazyQuery } from '@/types/vue-apollo-helpers';
import type { QueryGetTestResultsArgs, CbtTestPaginator, CbtTestResultPaginator } from '@/types/composition-functions';

export const useCBTTestResults = ({
  autoFetch = true,
  variables,
}: {
  autoFetch?: boolean;
  variables?: Ref<QueryGetTestResultsArgs | undefined> | (() => QueryGetTestResultsArgs);
}) => {
  // cache-and-network: scores change as sessions are graded, so a revisit must
  // not keep showing the cached list.
  const { result, loading, error, load, refetch } = useGetTestResultsLazyQuery(
    variables as QueryGetTestResultsArgs | Ref<QueryGetTestResultsArgs> | (() => QueryGetTestResultsArgs) | undefined,
    { fetchPolicy: 'cache-and-network' },
  );
  if (autoFetch) load();

  const data = computed(() => result.value?.getTestResults?.data || []);
  const paginatorInfo = computed(
    () => result.value?.getTestResults?.paginatorInfo || null,
  ) as ComputedRef<CbtTestResultPaginator['paginatorInfo'] | null>;

  return {
    testResults: {
      data,
      paginatorInfo,
      loading,
      error,
      refetch,
    },
    load,
    refetch,
  };
};
